import { useQuery } from "@tanstack/react-query";
import { privateAxios } from "../axiosInstances";
import eventsQueryKeys from "../query-keys/events.query-keys";
import {
  EventGate,
  EventGateFilters,
  PaginatedResponse,
} from "@ac-expo/api-types";
import { isAxiosError } from "axios";

const getEventGates = async (eventId: string) => {
  const res = await privateAxios.get<EventGate[]>(`/events/${eventId}/gates`);
  return res.data;
};

export const useGetEventGatesQuery = (eventId: string) => {
  return useQuery({
    queryKey: eventsQueryKeys.gates(eventId),
    queryFn: () => getEventGates(eventId),
    enabled: !!eventId,
  });
};

const getPaginatedEventGates = async (
  eventId: string,
  params?: EventGateFilters
) => {
  try {
    const res = await privateAxios.get<PaginatedResponse<EventGate>>(
      `/events/${eventId}/gates/paginated`,
      { params }
    );
    return res.data;
  } catch (error) {
    if (isAxiosError(error)) {
      throw {
        message: error.response?.data.message,
      };
    }
    throw error;
  }
};

export const useGetPaginatedEventGatesQuery = (
  eventId: string,
  params?: EventGateFilters
) => {
  return useQuery({
    queryKey: eventsQueryKeys.gates(eventId, params),
    queryFn: () => getPaginatedEventGates(eventId, params),
    enabled: !!eventId,
  });
};
